/**
 * Validação de senha com cálculo de força
 * Retorna objeto com validação completa e critérios atendidos
 */
export const validatePassword = (password) => {
	if (!password) {
		return {
			isValid: false,
			errors: ['A senha é obrigatória.'],
			strength: 0,
			criteria: {
				length: false,
				uppercase: false,
				lowercase: false,
				number: false,
				special: false
			}
		};
	}

	const criteria = {
		length: password.length >= 8,
		uppercase: /[A-Z]/.test(password),
		lowercase: /[a-z]/.test(password),
		number: /[0-9]/.test(password),
		special: /[^A-Za-z0-9]/.test(password)
	};

	const errors = [];
	
	if (!criteria.length) {
		errors.push('A senha deve ter pelo menos 8 caracteres.');
	}
	if (!criteria.uppercase) {
		errors.push('A senha deve conter pelo menos uma letra maiúscula.');
	}
	if (!criteria.lowercase) {
		errors.push('A senha deve conter pelo menos uma letra minúscula.');
	}
	if (!criteria.number) {
		errors.push('A senha deve conter pelo menos um número.');
	}
	if (!criteria.special) {
		errors.push('A senha deve conter pelo menos um caractere especial.');
	}

	// Calcular força da senha (0-100)
	const criteriaCount = Object.values(criteria).filter(Boolean).length;
	const baseStrength = (criteriaCount / 5) * 60; // Base de 60% para todos os critérios
	
	// Bônus por comprimento
	let lengthBonus = 0;
	if (password.length >= 12) {
		lengthBonus = 20;
	} else if (password.length >= 10) {
		lengthBonus = 10;
	} else if (password.length >= 8) {
		lengthBonus = 5;
	}
	
	// Bônus por complexidade (combinação de diferentes tipos)
	const hasMultipleTypes = [
		criteria.uppercase && criteria.lowercase,
		criteria.number && criteria.special,
		criteria.uppercase && criteria.number,
		criteria.lowercase && criteria.special
	].filter(Boolean).length;
	
	const complexityBonus = Math.min(hasMultipleTypes * 5, 20);
	
	const strength = Math.min(100, Math.round(baseStrength + lengthBonus + complexityBonus));

	return {
		isValid: errors.length === 0,
		errors,
		strength,
		criteria
	};
};

/**
 * Retorna texto descritivo da força da senha
 */
export const getPasswordStrengthText = (strength) => {
	if (strength < 40) {
		return 'Senha fraca';
	} else if (strength < 70) {
		return 'Senha média';
	} else {
		return 'Senha forte';
	}
};

/**
 * Retorna cor da barra de progresso baseada na força
 */
export const getPasswordStrengthColor = (strength) => {
	if (strength < 40) {
		return '#f44336'; // Vermelho
	} else if (strength < 70) {
		return '#ff9800'; // Laranja/Amarelo
	} else {
		return '#4caf50'; // Verde
	}
};
